import { useQuery } from '@tanstack/react-query';
import { PartnerService } from '../PartnerService';

export const usePartnerList = ({
  enabled = true,
  page = 1,
  pageSize = 200,
  search = '',
  partnerType,
  includeInactive = false,
} = {}) =>
  useQuery({
    queryKey: [
      'partners',
      'list',
      page,
      pageSize,
      search,
      partnerType,
      includeInactive,
    ],
    queryFn: () =>
      PartnerService.listPartners({
        page,
        pageSize,
        search,
        partnerType,
        includeInactive,
      }),
    enabled,
  });
